import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CourseSchedule } from 'src/app/models/course-schedule';
import { CourseMapper } from 'src/app/models/mappers/courser.mapper';
import { NextScheduledCoursesModel } from 'src/app/models/next-scheduled-courses.model';
import { CourseService } from 'src/app/services/course/course.service';
import { TrainingProgramApplicationUtils } from '../../utils/training-program-application.util';
import { ExternalLinkComponent } from '../external-link/external-link.component';
import { MatDialog } from '@angular/material/dialog';
import { FormatUtil } from 'src/app/utils/format.util';

@Component({
  selector: 'app-course-schedule-search-result-card',
  templateUrl: './course-schedule-search-result-card.component.html',
  styleUrls: ['./course-schedule-search-result-card.component.scss'],
  standalone: false
})
export class CourseScheduleSearchResultCardComponent implements OnInit {
  @Input() trainingSchedule: CourseSchedule;
  @Input() filteredFromDate: Date | null | undefined;
  @Input() filteredToDate: Date | null | undefined;
  @Input() isWorker: boolean = false;
  nextCourses: NextScheduledCoursesModel;
  courseMapper = new CourseMapper();
  currentLang: string = 'en'

  seatsAvailable: number;
  address: string;
  tpAppUtils = TrainingProgramApplicationUtils;
  formatUtil = FormatUtil
  isElearning: boolean = false;

  nextScheduledSameLocationDateCombo: string
  nextScheduledSameLocationTimeCombo: string
  nextScheduledSameLocationDayOfWeekCombo: string
  nextScheduledDifferentLocationDateCombo: string
  nextScheduledDifferentLocationTimeCombo: string
  nextScheduledDifferentLocationDayOfWeekCombo: string
  month: string = '';
  date: string = '';
  day: string = '';

  constructor(public translateService: TranslateService,
    public router: Router,
    private dialog: MatDialog,
    public route: ActivatedRoute,
    public cp: CurrencyPipe,
    public dp: DatePipe,
    @Inject('CourseService') public courseService: CourseService,) {
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
  }

  ngOnInit(): void {
    this.currentLang == 'en' ? this.dp = new DatePipe('en-CA') : this.dp = new DatePipe('Fr-CA')

    this.isElearning = this.trainingSchedule.TrainingTypeName.toLowerCase() === this.tpAppUtils.ELearningStr.toLowerCase();
    this.seatsAvailable = this.trainingSchedule.getSeatsAvailable();
    this.address = this.trainingSchedule.formatAddress();

    const month = this.dp.transform(this.trainingSchedule.FirstClassDate, 'MMMM')
    if (month != null)
      this.month = month.toUpperCase();

    const date = this.dp.transform(this.trainingSchedule.FirstClassDate, 'dd')
    if (date != null)
      this.date = date

    let day = this.dp.transform(this.trainingSchedule.FirstClassDate, "EEEE")
    if (day != null)
      this.day = day.toUpperCase();
  }

  expandOrCollapse() {
    this.courseService.GetNextCourseScheduled(this.trainingSchedule.CourseId).subscribe(data => {
      if (data) {
        let nextScheduledSameLoc = data.NextScheduledSameLocation != null ? CourseMapper.map([data.NextScheduledSameLocation])[0] : undefined
        let nextScheduledDifLoc = data.NextScheduledDifferentLocation != null ? CourseMapper.map([data.NextScheduledDifferentLocation])[0] : undefined
        this.nextCourses = new NextScheduledCoursesModel(nextScheduledSameLoc, nextScheduledDifLoc)

        if (this.nextCourses.NextScheduledDifferentLocation) {
          this.nextScheduledDifferentLocationDateCombo = this.nextCourses.NextScheduledDifferentLocation.getDatesAsComboString(this.dp)
          this.nextScheduledDifferentLocationTimeCombo = this.nextCourses.NextScheduledDifferentLocation.getTimeAsComboString(this.dp)
          this.nextScheduledDifferentLocationDayOfWeekCombo = this.nextCourses.NextScheduledDifferentLocation.getDaysOfWeekAsComboString(this.dp)
        }
        if (this.nextCourses.NextScheduledSameLocation) {
          this.nextScheduledSameLocationDateCombo = this.nextCourses.NextScheduledSameLocation.getDatesAsComboString(this.dp)
          this.nextScheduledSameLocationTimeCombo = this.nextCourses.NextScheduledSameLocation.getTimeAsComboString(this.dp)
          this.nextScheduledSameLocationDayOfWeekCombo = this.nextCourses.NextScheduledSameLocation.getDaysOfWeekAsComboString(this.dp)
        }

        this.trainingSchedule.Expanded = !this.trainingSchedule.Expanded
      }
    })
  }

  NavigateToEnrol() {
    let elecs = this.trainingSchedule?.ElectronicAddresses ?? [];
    const externalUrl = elecs.find(x => x.TypeName === 'VirtualClassUrl' || x.TypeName === 'ExternalRegistrationUrl')?.ElectronicAddressValue;

    if (externalUrl) {
      const dialogRef = this.dialog.open(ExternalLinkComponent, {
        width: '400px',
        data: externalUrl
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          window.open(externalUrl, '_blank');
        }
      });
    } else {
      this.isWorker ? this.router.navigate(['marketplace/enrolment/' + this.trainingSchedule.CourseId + '/worker']) :
        this.router.navigate(['/marketplace/enrolment/' + this.trainingSchedule.CourseId]);
    }
  }

  gotoTpWebsite(url: string) {
    window.open(url.toLocaleLowerCase().startsWith("http:") ? url : 'http://' + url);
  }
}
